type ProfileHostLike = {
  GetAccessToken?: unknown;
  OnClose?: unknown;
  OnSave?: unknown;
};

export function getProfileHostFromWindow(win: Window = window): ProfileHostLike | null {
  return (win as any)?.chrome?.webview?.hostObjects?.ProfileHost ?? null;
}

/**
 * Hosted path when HTML auth is present, or when ProfileHost exists in WebView (token resolved async in HostedMFE).
 * Do not sniff GetAccessToken on the host object — WebView2 proxies are truthy even when the method is absent.
 */
export function shouldUseHostedMFE(mfeAuthToken: string, profileHost: ProfileHostLike | null): boolean {
  if (mfeAuthToken) {
    return true;
  }

  return profileHost != null;
}

/** Invoke host GetAccessToken without letting synchronous throws escape the effect. */
export function invokeProfileHostGetAccessToken(profileHost: ProfileHostLike): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const getAccessToken = profileHost?.GetAccessToken;
      if (getAccessToken == null) {
        reject(new Error('GetAccessToken is not available'));
        return;
      }

      const result =
        typeof getAccessToken === 'function' ? getAccessToken.call(profileHost) : getAccessToken;

      Promise.resolve(result).then((value) => {
        if (typeof value === 'string') {
          resolve(value);
          return;
        }
        reject(new Error('GetAccessToken returned a non-string'));
      }).catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}
